import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const ErrorPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <Typography variant="h1" >
        404
      </Typography>
      <Typography variant="h6" >
        {t("error.404")}
      </Typography>
        <Button variant="contained" onClick={() => navigate("/")}>{t("button.home")}</Button>

    </Box>
  );
};

export default ErrorPage;
